import { render, staticRenderFns } from "./FightersTitle.vue?vue&type=template&id=d66924ec&lang=pug&"
import script from "./FightersTitle.vue?vue&type=script&lang=js&"
export * from "./FightersTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports